window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('select2');

$.fn.wordCount = function(el) {

    $(this).on('keyup', function(e) {

        $thisId = $(this).attr('id');
        var wordCountId = $thisId + 'WordCount';
        var wordCountIdEscaped = $thisId.replace('.', '\\.') + 'WordCount';

        if ($('#' + wordCountIdEscaped).length === 0) {
            $(this).after('<small class="text-muted" id="' + wordCountId + '">0 words</small>');
        }

        var words = $(this).val().replace(/^[\s,.;]+/, "").replace(/[\s,.;]+$/, "").split(/[\s,.;]+/).length;

        if ($(this).val() == '') {
            words = 0;
        }

        $('#' + wordCountIdEscaped).text(words + ' words');
    }).trigger('keyup');
};
